import { dateFormatDisplayShort, formatISODate } from 'lib';

export const formattedCosDate = (date: string) =>
  formatISODate(date, dateFormatDisplayShort);
